import { trackError } from '#api/errors.ts';
import { CopyButton } from '#components/atoms/buttons/copy-button/CopyButton.tsx';
import { OSCard } from '#components/atoms/cards/os-card/OSCard.tsx';
import type { ArchOption, ClientInfo, OSGroup } from '#dn-types/downloads.ts';
import styles from './PlatformCard.module.css';

type Props = {
  os: OSGroup;
  platforms: ClientInfo[];
};

const KEYS_TO_SHOW = [
  'linux-amd64',
  'linux-arm64',
  'linux-armv7',
  'macos-universal-server',
  'macos-universal-server-dmg',
  'macos-universal-desktop',
  'windows-amd64-server',
  'windows-arm64-server',
  'windows-amd64-desktop',
  'windows-arm64-desktop',
  'android',
  'ios',
  'docker',
] satisfies ArchOption[];

export function PlatformCard({ os, platforms }: Props) {
  return (
    <OSCard os={os}>
      {platforms
        .filter((platform) => KEYS_TO_SHOW.includes(platform.key))
        .map((platform) => {
          const isLink = platform.type === 'url';

          const copyable = isLink ? platform.url : platform.download;
          if (!copyable) {
            // This shouldn't happen, it's a side effect of some typing decisions
            trackError('PlatformCard: Got a platform that had no url or download link to copy');
            return null;
          }

          return (
            <div className={styles.PlatformCard_architectureRow} key={platform.key}>
              <a className="a p-md" href={platform.url} download>
                {platform.label}
              </a>
              <CopyButton value={copyable} initialTooltip={isLink ? 'Copy url' : 'Copy curl command'} />
            </div>
          );
        })}
    </OSCard>
  );
}
